import { Component } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { ToggleService } from '../header/toggle.service';
import { CustomizerSettingsService } from '../../../../components/customizer-settings/customizer-settings.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Clipboard } from '@angular/cdk/clipboard';
import { ProfessionalReportService } from '../../../services/professional-report.service';
import { StorageService } from '../../../services/storage.service';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
})
export class SidebarComponent {
  panelOpenState = false;

  isToggled = false;

  public environment = environment;

  constructor(
    private toggleService: ToggleService,
    public themeService: CustomizerSettingsService,
    private readonly professionalReportService: ProfessionalReportService,
    private snackbar: MatSnackBar,
    private clipboard: Clipboard,
    private storageService: StorageService,
    private router: Router,
  ) {
    this.toggleService.isToggled$.subscribe((isToggled) => {
      this.isToggled = isToggled;
    });

    //BugFix: Fecha o menu automaticamente após a navegação
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        if (this.isToggled) {
          this.toggleService.toggle();
        }
      });
  }

  toggle() {
    this.toggleService.toggle();
  }

  toggleSidebarTheme() {
    this.themeService.toggleSidebarTheme();
  }

  toggleHideSidebarTheme() {
    this.themeService.toggleHideSidebarTheme();
  }

  getRole() {
    return this.storageService?.getUser()?.role;
  }

  public isAdminOrSuperAdmin(): boolean {
    const role = this.getRole();
    return role === 'ADMIN' || role === 'SUPERADMIN';
  }

  getClipboardRegisterProfessional() {
    this.snackbar.open('Copiado para área de transferência', '', {
      duration: 3000,
    });
    this.clipboard.copy(
      this.environment.urlRegisterProfessional
    );
  }

  professionalExportSpreadsheet() {
    this.snackbar.open('Aguarde, gerando relatório...', '', {
      duration: 3000,
    });
    this.professionalReportService.generateSpreadsheet().subscribe(() => {
      this.snackbar.open('Relatório gerado com sucesso', '', {
        duration: 3000,
      });
    });
  }
}
